(function () {
  "use strict";
  var body = document.body;
  var overlay = document.getElementById("br-age-overlay");
  var form = document.getElementById("br-age-form");
  var birthday = document.getElementById("br-age-birthday");
  var message = document.getElementById("br-age-message");
  if (!overlay || !form || !birthday || !message) return;
  var flag = "brkiosk_18plus_confirmed_session_v1";

  function setError(txt) {
    message.textContent = txt;
    message.hidden = false;
    birthday.setAttribute("aria-invalid", "true");
  }

  function approved() {
    overlay.hidden = true;
    overlay.setAttribute("aria-hidden", "true");
    body.classList.remove("br-age-locked");
    body.classList.add("br-age-approved");
  }

  try {
    if (window.sessionStorage.getItem(flag) === "yes") {
      approved();
      return;
    }
  } catch (e) { /* Gate still works when storage is disabled. */ }

  var today = new Date();
  var currentYear = today.getFullYear();
  var currentMonth = String(today.getMonth() + 1).padStart(2, "0");
  var currentDay = String(today.getDate()).padStart(2, "0");
  birthday.max = currentYear + "-" + currentMonth + "-" + currentDay;
  overlay.hidden = false;
  window.requestAnimationFrame(function () { birthday.focus({ preventScroll: true }); });

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    message.hidden = true;
    birthday.removeAttribute("aria-invalid");
    var input = birthday.value;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(input)) {
      setError("Bitte gib ein vollständiges Geburtsdatum ein.");
      return;
    }
    var parts = input.split("-").map(Number);
    var year = parts[0], month = parts[1], day = parts[2];
    var exactDate = new Date(year, month - 1, day);
    if (
      year < 1900 || year > currentYear ||
      exactDate.getFullYear() !== year ||
      exactDate.getMonth() !== month - 1 ||
      exactDate.getDate() !== day ||
      exactDate.getTime() > today.getTime()
    ) {
      setError("Bitte gib ein gültiges Geburtsdatum ein.");
      return;
    }
    var age = currentYear - year;
    if (today.getMonth() + 1 < month ||
      (today.getMonth() + 1 === month && today.getDate() < day)) age--;
    if (age < 18) {
      setError("Der BRKiosk-Shop ist nur für Personen ab 18 Jahren zugänglich.");
      return;
    }
    try { window.sessionStorage.setItem(flag, "yes"); } catch (e) {}
    approved();
  });
})();